import { useQuery } from "@tanstack/react-query";
import PageLayout from "../../../layouts/pageLayout/pageLayout";
import styles from "./styles.module.scss";
import { getDashboardStatus } from "../../../utils/request";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../utils/store";
import { Spin } from "antd";
import ProgramInfo from "../../../components/programInfo";
import { getNormalizedModeOfEntry } from "../../../utils";
import { useGetApplicantDetailsQuery } from "../../../hooks/api/useGetApplicantDetailsQuery";

const Dashboard = () => {
  const storedUser = useAtomValue(userAtom);
  const { applicantDetails } = useGetApplicantDetailsQuery({
    applicantId: storedUser?.applicantId,
  });
  const user = applicantDetails ?? storedUser;

  const { data, isLoading } = useQuery({
    queryKey: ["dashboard-status"],
    queryFn: () => getDashboardStatus(user?.applicantId ?? ""),
  });

  const dashboardData = data?.data ?? ({} as DashboardStatus);
  const isMscApplicant = user?.programType?.toLowerCase()?.includes("msc");
  const normalizedModeOfEntry = getNormalizedModeOfEntry(user?.modeOfEntry);
  const isUtmeApplicant = normalizedModeOfEntry?.includes("utme");
  const isUtmeSubmitted =
    dashboardData?.isUTMESubmitedSubmitted ??
    dashboardData?.isUTMESubmitted ??
    false;
  const isWorkHistorySubmitted = dashboardData?.isWorkHistorySubmitted;
  const progressLabel = isMscApplicant ? "Work History" : "UTME Result";
  const progressStatus = isMscApplicant
    ? isWorkHistorySubmitted
    : isUtmeSubmitted;
  const shouldShowProgressCard = isMscApplicant || isUtmeApplicant;

  const getStatus = (status: boolean) => {
    if (status) {
      return "Completed";
    } else {
      return "Pending";
    }
  };

  const displayStyle = (status: boolean | null) => {
    if (status === true) {
      return styles.completed;
    } else if (status === null) {
      return styles.pending;
    } else {
      return styles.rejected;
    }
  };

  const getAdmissionStatusStyle = (status: 1 | 2 | 3 | null) => {
    if (status === 1) {
      return styles.completed;
    } else if (status === 2) {
      return styles.rejected;
    } else {
      return styles.pending;
    }
  };

  const getAdmissionStatus = () => {
    if (dashboardData?.isAdmitted === 1) {
      return "Admitted";
    }
    if (dashboardData?.isAdmitted === 2) {
      return "Not Admitted";
    }
    return "Pending";
  };

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <>
      <PageLayout heading="Dashboard">
        <ProgramInfo className={styles.rectangle} />
        <br />
        <div className={styles.rectangle}>
          <p>Bio-data</p>
          <p className={displayStyle(dashboardData?.isPersonalInfoSubmitted)}>
            {getStatus(dashboardData?.isPersonalInfoSubmitted)}
          </p>
        </div>

        {user &&
          (user.programType?.toLowerCase()?.includes("msc") ||
            user.programType?.toLowerCase()?.includes("mba") ||
            normalizedModeOfEntry?.includes("directentry")) && (
            <div className={styles.rectangle}>
              <p>Institution</p>
              <p
                className={displayStyle(dashboardData?.isInstitutionSubmitted)}
              >
                {getStatus(dashboardData?.isInstitutionSubmitted)}
              </p>
            </div>
          )}

        {user &&
          (user.programType?.toLowerCase()?.includes("msc") ||
            user.programType?.toLowerCase()?.includes("mba") ||
            normalizedModeOfEntry?.includes("directentry")) && (
            <div className={styles.rectangle}>
              <p>Work History</p>
              <p
                className={displayStyle(dashboardData?.isWorkHistorySubmitted)}
              >
                {getStatus(dashboardData?.isWorkHistorySubmitted)}
              </p>
            </div>
          )}

        {user && user?.programType?.toLowerCase()?.includes("bsc") && (
          <div className={styles.rectangle}>
            <p>Qualification</p>
            <p
              className={displayStyle(dashboardData?.isQualificationSubmitted)}
            >
              {getStatus(dashboardData?.isQualificationSubmitted)}
            </p>
          </div>
        )}

        {shouldShowProgressCard && (
          <div className={styles.rectangle}>
            <p>{progressLabel}</p>
            <p className={displayStyle(progressStatus)}>
              {getStatus(progressStatus)}
            </p>
          </div>
        )}

        <div className={styles.rectangle}>
          <p>Application Fee Payment</p>
          <p className={displayStyle(dashboardData?.isPaymentSubmitted)}>
            {getStatus(dashboardData?.isPaymentSubmitted)}
          </p>
        </div>

        <div className={styles.rectangle}>
          <p>Admission Status</p>
          <p className={getAdmissionStatusStyle(dashboardData?.isAdmitted)}>
            {getAdmissionStatus()}
          </p>
        </div>
      </PageLayout>
    </>
  );
};
export default Dashboard;
